import { logUsage } from 'owa-analytics';
import { FluidLoadSource, FluidLoadOwaScenario } from './FluidEnums';
import { trace } from 'owa-trace';

export default function fluidComponentError(
    owaScenario: FluidLoadOwaScenario,
    source: FluidLoadSource,
    error?: Error
) {
    logUsage('FluidComponentError', {
        OwaScenario_1: owaScenario,
        ComponentSource_2: source,
    });

    if (error) {
        error.name = '[FluidComponentError] ' + error.name;
        trace.error(error);
    }
}
